import { SimpleGrid } from '@chakra-ui/react'
import type { NextPage } from 'next'
import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { getList } from 'services/tips/action'

import Layout from 'components/Layout/Default'
import Container from 'components/Container'
import CardLeaft from 'components/CardLeaf'
import TipsImage from 'public/images/dica-image-1.jpg'

import Link from 'next/link'
import { transformHttpToHttps } from 'utils'
import { useRouter } from 'next/router'

const Dicas: NextPage<any> = ({ data }) => {
  const router = useRouter()

  return (
    <Layout
      category="Dicas"
      title="Dicas de grama, cuidados e manutenção"
      description="Nessa sessão do site, você vai aprender as principais dicas de como plantar, cuidar e manter o seu gramado bonito e saudável, além de dicas para remoção de pragas..."
      keywords="dicas de grama, dicas de como plantar grama, dicas de plantio de grama, dicas como para plantar grama esmeralda, dicas de manutenção de grama, dicas de manutenção de gramdo, dicas de grama para jardim, dicas de como combater ervas daninhas, dicas de como remover pragas na grama"
      links={router.asPath}
      categorySize="1.6rem"
    >
      <section>
        <Container>
          <SimpleGrid columns={[1, 1, 2, null, 3]} spacing={15}>
            {data?.map((item: any) => (
              <Link
                key={`tip-${item.id}`}
                href={`/dicas/${item.slug}`}
                passHref
              >
                <a>
                  <CardLeaft
                    image={
                      transformHttpToHttps(item.x_featured_media_original) ||
                      TipsImage
                    }
                    title={item.title.rendered}
                    time={format(new Date(item.date), 'EEEE, d MMMM, Y ', {
                      locale: ptBR,
                    })}
                    author={item.x_author}
                    photo={item?.author.author_avatar}
                    metaImgTitle={item?.acf?.title_img_othertips}
                    metaImgAlt={item?.acf?.alt_img_othertips}
                    metaTitle={item?.acf?.title_text_othertips}
                  />
                </a>
              </Link>
            ))}
          </SimpleGrid>
        </Container>
      </section>
    </Layout>
  )
}

export async function getStaticProps() {
  const data = await getList()

  return {
    props: {
      data
    },
    revalidate: 10
  }
}

export default Dicas
